<template>
  <GridBase timelineKr>
    <div class="menu" v-if="this.dataList">
      <slider ref="timeline" @click="changeNow" :navigation="true" :pagination="false" :option="{ watchOverflow: true, loop: false, slidesPerView: 'auto', spaceBetween: 20,
        breakpoints: {
          768: { spaceBetween: 40 },
          1024: { spaceBetween: 30 },
          1600: { spaceBetween: 40 },
        }}">
        <div class="swiper-slide" :class="{on: now.seq === item.seq}" v-for="item in dataList" :key="item.seq" :data-click="item.seq">
          <p v-html="item.title"/>
          <p v-html="splitYmd(item.timelineYmd, '. ')"/>
        </div>
        <s class="stick" :style="{ width: stickWidth, left: stickLeft }"/>
      </slider>
    </div>
    <div class="content" v-if="now.title">
      <div class="txt">
        <p v-html="now.title"/>
        <p v-html="now.content"/>
      </div>
      <div class="media">
        <!-- <div class="tab">
          <a :class="{on: media === 'video'}" @click="media = 'video'" v-if="now.videoUrl">VIDEO</a>
          <a :class="{on: media === 'photos'}" @click="media = 'photos'" v-if="now.timelineAttachList && now.timelineAttachList.length">PHOTOS</a>
        </div> -->
        <div class="video" :class="{on: media === 'video'}" :key="'video' + media + now.seq" v-if="now.videoUrl">
          <div class="video-size">
            <iframe v-if="sect === 'sm' || media === 'video'" :src="now.videoUrl" frameborder='no' scrolling='no' marginwidth='0' marginheight='0' allow='autoplay' allowfullscreen></iframe>
          </div>
        </div>
        <!-- <div class="photos" :class="{on: media === 'photos'}" :key="'photo' + media + now.seq" v-if="now.timelineAttachList && now.timelineAttachList.length">
          <h3>PHOTOS</h3>
          <slider type="view" :navigation="true" :option="{ loop: false, pagination: { type: 'fraction' } }" use-thumbs ref="view01">
            <img :src="item.urlPath" alt="" class="swiper-slide" :key="item.seq" v-for="item in now.timelineAttachList">
          </slider>
          <slider type="thumb" :navigation="true" :pagination="false" :option="{
            slidesPerView: 'auto',
            spaceBetween: 10,
            loop: false,
            watchSlidesVisibility: true,
            watchSlidesProgress: true
          }" @initialized="thumbsInitialized">
            <img :src="item.urlPath" alt="" class="swiper-slide" :key="item.seq" v-for="item in now.timelineAttachList">
          </slider>
        </div> -->
      </div>
    </div>
  </GridBase>
</template>
<script>
import _ from 'lodash';
import GridBase from '@/views/components/GridBase';
import Slider from '@/views/components/Slider';

export default {
  components: { Slider, GridBase },
  data() {
    return {
      stickWidth: 0,
      stickLeft: '50%',
      media: 'video',
      now: {},
      thumbs: null,
      dataList: [
        { seq: 1, title: '데이터센터 각 세종 : THANKS TO', content: '우리에게 각 세종이란 무엇일까요?<br> 각 세종의 길을 함께 달려온, 그리고 앞으로의 미래를 함께 나아갈 많은 분들의 마음 속 "나에게 각 세종이란" 의미를 되새겨보며 감사한 마음을 나눠봅니다.', videoUrl: 'https://tv.naver.com/embed/37542293?autoPlay=true', timelineYmd: '2023. 06', timelineAttachList: [{ seq: 1, urlPath: '' }] },
        { seq: 2, title: '데이터센터 각 세종 : 건축의 환경 겨울', content: '2022년 겨울, 다음해의 따뜻한 봄을 기다리듯 땅이 얼고 눈이 쌓인 이곳 세종에서 네이버의 미래를 기다립니다.', videoUrl: 'https://tv.naver.com/embed/38346847?autoPlay=true', timelineYmd: '2023. 02', timelineAttachList: [{ seq: 2, urlPath: '' }] },
        { seq: 3, title: '데이터센터 각 세종 : 건축의 환경 가을', content: '각3022년 가을, 유독 높아진 가을 하늘을 닮아, 한 계단 한 계단 각 세종이 쌓아 올려지고 있습니다.', videoUrl: 'https://tv.naver.com/embed/38635073?autoPlay=true', timelineYmd: '2022. 11', timelineAttachList: [{ seq: 3, urlPath: '' }] },
        { seq: 4, title: '데이터센터 각 세종 : 건축의 환경 여름', content: '2022년 여름, 자연 그대로의 시간을 담아 자연과 만나는 건축의 태도를 생각하고 우리가 지켜야할 가치를 기록합니다.', videoUrl: 'https://tv.naver.com/embed/30304747?autoPlay=true', timelineYmd: '2022. 08', timelineAttachList: [{ seq: 4, urlPath: '' }] },
        { seq: 5, title: '데이터센터 각 세종 : 건축의 환경 봄', content: '2022년 봄, 땅을 다지고 씨앗을 뿌리는 마음으로 분주하게 움직이는 각 세종 현장을 기록합니다.', videoUrl: 'https://tv.naver.com/embed/28481473?autoPlay=true', timelineYmd: '2022. 05', timelineAttachList: [{ seq: 5, urlPath: '' }] },
        { seq: 6, title: '데이터센터 각 세종 : 디자인 컨셉', content: '연결과 확장<br><br>각 세종은 각 춘천의 안전과 보관이라는 의미를 유지하며 시대의 연결, 데이터와 기술의 연결, 사람과 일상과의 연결을 통해 새로운 가치를 담으며 끊임없이 확장합니다.', videoUrl: 'https://tv.naver.com/embed/27489853?autoPlay=true', timelineYmd: '2022. 06', timelineAttachList: [{ seq: 6, urlPath: '' }] },
        { seq: 7, title: '네이버 데이터센터 각 세종 : THANKS TO', content: '각 세종의 설계를 끝맺음 하면서 그동안의 발자취를 담은 감사의 이야기를 전해드립니다.', videoUrl: 'https://tv.naver.com/embed/22798256?autoPlay=true', timelineYmd: '2021. 10', timelineAttachList: [{ seq: 7, urlPath: '' }] },
        { seq: 8, title: '데이터센터 각 세종 : 파이널플랜 02', content: '설계공모부터 20개월, 멀리서 보면 마라톤 같은, 그러나 가까이서 보면 언제나 100미터 질주 같던 긴 시간들이 모여 각 세종의 파이널플랜이 그 모습을 드러냈습니다.', videoUrl: 'https://tv.naver.com/embed/22831043?autoPlay=true', timelineYmd: '2021. 10', timelineAttachList: [{ seq: 8, urlPath: '' }] },
        { seq: 9, title: '데이터센터 각 세종 : 파이널플랜 01', content: '천혜의 자연경사지와 첨단산업시설이라는 서로 상반되어 보이는 두가지의 모습들을 어떤 식으로 조화롭게 만들며 상호 보완할 수 있을지 고민했습니다. 각 세종이라는 큰 매스의 건축물이 들어서더라도 주변의 자연이 훼손되지 않고 자연의 모습 그대로를 담기 위해 원형지에 대한 많은 공부를 하고 좀 더 근본적으로, 그리고 좀 더 진지하게 친환경이 무엇인지 생각했습니다.', videoUrl: 'https://tv.naver.com/embed/22786276?autoPlay=true', timelineYmd: '2021. 10', timelineAttachList: [{ seq: 9, urlPath: '' }] },
        { seq: 10, title: '데이터센터 각 세종 건축을 위한 준비', content: '원래 이곳에서 살고 있던 생명체들과 새롭게 이사를 들어온 사람들, 서로가 함께 잘 살기 위해서는 그 존재들을 잘 아는 것이 먼저 중요하지 않을까 생각했습니다. 그래서 우리는 각 세종이 놓여질 부지를 조성하는 일에 앞서, 이 곳에 숲과 여러 생명체들이 존재하였다는 사실을 함께 기억하고 싶은 바람을 담아 그 존재들을 기록합니다.', videoUrl: 'https://tv.naver.com/embed/21165824?autoPlay=true', timelineYmd: '2021. 07', timelineAttachList: [{ seq: 10, urlPath: '' }] },
        { seq: 11, title: '데이터센터 각 세종 온라인 기공식', content: '각 세종은 글로벌 최고 수준의 데이터센터를 목표로 건축공사에 본격 착수하였습니다. 데이터센터 본연의 기술과 로봇/AI/클라우드 등 핵심기술을 집약하여 4차 산업혁명을 대표하는 Hi-Tech 건축의 이정표를 제시하고자 합니다.', videoUrl: 'https://tv.naver.com/embed/19764594?autoPlay=true', timelineYmd: '2021. 04', timelineAttachList: [{ seq: 11, urlPath: '' }] },
        { seq: 12, title: '데이터센터 각 세종 테크-로봇', content: '데이터센터라는 공간자체가 스스로를 돌볼 줄 하는 하나의 머신처럼 보이는 모습을 기대합니다. 네이버는 그 꿈을 이루기 위한 첫 발자국을 이제 막 떼었습니다. 데이터센터 각 세종과 함께 공존할 네이버의 로봇과 자율주행기술에 대한 이야기를 들려드립니다.', videoUrl: 'https://tv.naver.com/embed/19333239?autoPlay=true', timelineYmd: '2021. 04', timelineAttachList: [{ seq: 12, urlPath: '' }] },
        { seq: 13, title: '데이터센터 각 세종  테크-파사드', content: '각 세종의 파사드 디자인에는 자연의 훼손을 최소화하고 자연의 변형이 없이 건물을 앉히고자 하는 네이버의 마음이 들어있습니다. 구조체이면서도 입면을 형성할 수 있는 재료인 콘크리트와 페인트나 코팅을 적용하지 않는 친환경 알루미늄을 함께 사용함으로써 파사드의 기능과 디자인을 극대화했습니다.', videoUrl: 'https://tv.naver.com/embed/18532723?autoPlay=true', timelineYmd: '2021. 02', timelineAttachList: [{ seq: 13, urlPath: '' }] },
        { seq: 14, title: '데이터센터 각 세종 테크-에너지', content: '앞으로 10년, 20년, 오랜 기간 운영될 데이터센터 각 세종이 어떠한 지속가능성을 품고 있어야 할지에 대해 많은 고민을 거듭했습니다. 자연이 숨쉬듯 서버도 편안히 숨쉴 수 있는 건축물, 그리고 자연에너지를 활용하고 더 효율적으로 에너지를 사용하는 건축물을 만들기 위한 많은 기술과 고민의 흔적들을 각 세종에 담았습니다.', videoUrl: 'https://tv.naver.com/embed/16978156?autoPlay=true', timelineYmd: '2020. 12', timelineAttachList: [{ seq: 14, urlPath: '' }] },
        { seq: 15, title: '데이터센터 각 세종 마스터플랜', content: '각 세종 프로젝트의 가장 큰 고민은 원형지 상태의 자연과 공존하면서 어떤 형태와 어떤 방식으로 건축물을 자연에 앉힐지에 대한 것이었습니다. 자연과 인공물의 상호 관계 관점에서 평가하고 자연을 보다 적극적으로 이용할 수 있는 방향으로 디벨롭된 각 세종의 마스터플랜입니다.', videoUrl: 'https://tv.naver.com/embed/15704002?autoPlay=true', timelineYmd: '2020. 09', timelineAttachList: [{ seq: 15, urlPath: '' }] },
        { seq: 16, title: '자연을 대하는 각 세종의 자세', content: '8만9천평. 결코 적지 않은 각 세종의 사이트에는 곧게 자란 소나무와 버드나무 군락이 있고, 계곡을 따라 흐르는 실개천이 있습니다. 데이터센터 각 세종은 이 자연에 자리를 잡을 예정이지만 그 전에 이 자연과 만나는 각 세종은 어떤 태도이어야 하는지 생각해보았습니다. 잠시 빌린 이 땅을 적당한 선에서 개발 하는 것이 우리의 몫일테고, 이 땅을 다시 자연에게 돌려줬을 때 무리 없이 다시 채워가게 하는 것이 우리가 가질 태도 일 것입니다.​', videoUrl: 'https://tv.naver.com/embed/14475073?autoPlay=true', timelineYmd: '2020. 06', timelineAttachList: [{ seq: 16, urlPath: '' }] },
        { seq: 17, title: '데이터센터 각 세종 설계 공모', content: '209일이라는 기간 동안 데이터센터 각 세종을 함께 만들어 갈 파트너를 찾는 공모전을 진행하였습니다. 이 과정에 45개의 팀과 99명의 사람들이 함께해 주었고 12,987컷의 사진으로 기록되었습니다. 11분 13초로 축적된 기록을 통해 데이터센터 각 세종을 만들어가는 여정의 시작을 함께 할 수 있습니다.', videoUrl: 'https://tv.naver.com/embed/12436213?autoPlay=true', timelineYmd: '2020. 02', timelineAttachList: [{ seq: 17, urlPath: '' }] }
      ]
    };
  },
  watch: {
    $route: 'routed',
  },
  methods: {
    hasContent(data) {
      return data.content || data.videoUrl || (data.timelineAttachList && data.timelineAttachList.length);
    },
    changeNow(val) {
      const numericVal = Number(val);

      const data = _.find(this.dataList, row => row.seq === numericVal);

      if (!data || !this.hasContent(data)) {
        return;
      }
      
      this.now = data;
      this.media = this.now.videoUrl ? 'video' : 'photos';
      this.stickUpdate();
    },
    thumbsInitialized(thumbsSwiper) {
      this.$refs.view01.init(thumbsSwiper);
    },
    routed() {
      this.stickUpdate();
    },
    resized() {
      this.stickUpdate();
    },
    stickUpdate() {
      if (this.$el) {
        this.thumbs = this.$refs.thumbs;
        this.$nextTick(() => {
          const subItem = this.$el.querySelector('.menu .on');
          if (subItem) {
            this.stickWidth = `${subItem.offsetWidth}px`;
            this.stickLeft = `${subItem.offsetLeft}px`;
          } else {
            this.stickWidth = 0;
            this.stickLeft = '50%';
          }
        });
      }
    },
  },
  mounted() {
    this.dataList.forEach(row => { row.content = _.unescape(row.content); });
    let index = this.dataList.length - 1;
    while (!this.hasContent(this.now)) {
      this.now = this.dataList[index--];
    }

    if (this.dataList.length > 0) {
      this.now = this.dataList[0];
      this.media = this.now.videoUrl ? 'video' : 'photos';
    }

    setTimeout(() => {
      this.$refs.timeline.go(this.dataList.indexOf(this.now));
    }, 300);
    if (this.$el) {
      window.addEventListener('resize', _.debounce(this.resized, 100));
    }
  },
};
</script>